module.exports = __webpack_public_path__ + "img/homepage.65b571ab.jpg";